import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Navbar from "../layout/Navbar";
import CoverPhoto from "../assests/Images/about-us-cover-photo.jpg";
import imageTwo from "../assests/Images/about-three.jpg";
import imageThree from "../assests/Images/about-us-four.jpg";
import { toast, ToastContainer } from "react-toastify";
import certificateOne from "../assests/Images/certificate.jpg";
import certificateOTwo from "../assests/Images/ISO 9001 Cert (1)_page-0001.jpg";
import "swiper/css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import useIsMobile from "../core/hooks/isMobile";

import contactUsBg from "../assests/Images/contact-us-bg.jpg";
import { useForm } from "react-hook-form";
import Footer from "../layout/Footer";
import axios from "axios";
import { useInView } from "react-intersection-observer";
import WaveEffect from "../Components/WaveEffect";
import { GiFlatStar } from "react-icons/gi";
import emailjs from "@emailjs/browser";
import Toast from "../Components/Toast";
import { useRef, useState } from "react";

const AboutUs = () => {
  const isMobile = useIsMobile();

  const { ref: ref1, inView: inView1 } = useInView({
    triggerOnce: false,
    threshold: 0,
  });
  const { ref: ref2, inView: inView2 } = useInView({
    triggerOnce: false,
    threshold: 0,
  });
  const { ref: ref3, inView: inView3 } = useInView({
    triggerOnce: false,
    threshold: 0,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const formRef = useRef(null);
  const serviceId = process.env.REACT_APP_EMAIL_JS_SERVICE_ID || "";
  const templateId = process.env.REACT_APP_EMAIL_JS_TEMP_ID || "";
  const publicId = process.env.REACT_APP_EMAIL_JS_PUBLIC_ID || "";

  const handleOnSubmit = () => {
    if (formRef.current) {
      emailjs
        .sendForm(serviceId, templateId, formRef.current, {
          publicKey: publicId,
        })
        .then((response) => {
          if (response.status === 200) {
            toast.success("Request sent successfully!", {
              autoClose: 4000,
            });
            formRef.current.reset();
          } else if (response.status === 400) {
            toast.error("Bad request, Please check the form", {
              autoClose: 4000,
            });
          } else if (response.status === 500) {
            toast.error("Failed to send request. Please try again.", {
              autoClose: 4000,
            });
          } else {
            toast.error({
              message: `Error: ${response.statusText}`,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.error("EmailJS Error:", error);
          toast.error("Failed to send request. Please try again.", {
            autoClose: 4000,
          });
        });
    }
  };
  return (
    <>
      <Navbar />
      <ToastContainer />
      <div
        className="bg-cover bg-center h-screen lg:h-[80vh] md:h-[500px] sm:h-[400px] "
        style={{ backgroundImage: `url(${CoverPhoto})` }}
      >
        <div className="h-full  bg-black bg-opacity-60 w-full flex flex-col justify-center items-center ">
          <h1 className="text-white text-4xl lg:text-6xl font-bold leading-tight">
            ABOUT US
          </h1>
          <div className="h-1  mt-4 w-20 bg-white" />
          <p className="text-center xl:text-xl w-5/6 text-white">
            People Process Teck Private Limited is a leading force in HR and
            productivity interventions, providing a comprehensive suite of Human
            Resource Services and Support across diverse sectors and industries.
            Our mission is to empower our business partners with tailored
            solutions that enhance organizational effectiveness and drive
            measurable success.
          </p>
        </div>
      </div>

      <div className="h-[50rem] lg:h-[40rem] xl:h-[40rem] 2xl:h-[40rem] w-full bg-white grid lg:grid-cols-2 ">
        <div className=" flex flex-col justify-center items-center xl:px-6">
          <h1 className="text-4xl font-bold text-gray-900 leading-tight">
            Enabling Change.
          </h1>
          <h1 className="text-4xl font-bold text-gray-900 leading-tight">
            <span className="text-primary">Managing Transition.</span>
          </h1>
          <h1 className="text-4xl font-bold text-gray-900 leading-tight">
            Delivering Results.
          </h1>

          <h1 className="mt-4 text-gray-900 text-center ">
            We empower your organization to embrace necessary transformations
            with confidence and strategic clarity. By meticulously guiding your
            teams through every phase of the shift, we minimize operational
            disruption and ensure the seamless adoption of new workflows. Our
            proven methodologies focus on turning these complex challenges into
            measurable, sustainable outcomes that drive your core objectives
            forward. Ultimately, we partner with you from the initial spark of
            innovation to the final realization of tangible, long-term success.
          </h1>
        </div>
        <div className="flex justify-center items-center relative">
          <img
            src={imageThree}
            alt=""
            className="h-[12rem] w-[12rem] lg:h-[17rem] lg:w-[17rem] xl:h-[17rem] xl:w-[17rem] 2xl:h-[17rem] 2xl:w-[17rem] absolute top-[35%] lg:top-[50%] xl:top-[50%] 2xl:top-[50%]"
          />
          <img
            src={imageTwo}
            alt=""
            className="h-[16rem] w-[18rem] lg:h-[25rem] lg:w-[25rem] xl:h-[20rem] xl:w-[25rem] 2xl:h-[25rem] 2xl:w-[25rem]"
          />
        </div>
      </div>
      <div className="w-full bg-gray-100 h-[70rem] lg:h-[40rem] my-10  xl:py-10">
        <div ref={ref2} className="flex justify-center flex-col items-center">
          <h1 className="text-4xl font-bold text-gray-900 leading-tight">
            Execution Excellence -{" "}
            <span className="text-primary">Making Things Happen</span>{" "}
          </h1>
        </div>
        <p className="mt-4 text-center px-4 lg:px-10 xl:px-28 2xl:px-12">
          We work closely with our clients to understand their strategies,
          challenges, and growth objectives. From there, we execute meticulously
          planned interventions through workshops, outbound activities,
          simulations, training, executive coaching, and counseling. Our
          seasoned facilitators are committed to delivering impactful, tangible
          results.
        </p>

        <div className="flex flex-col xl:flex-row lg:flex-row justify-center items-center xl:gap-48 gap-20 mt-24">
          <div className="group relative  w-80 sm:w-96 xl:w-1/3 h-80 bg-white overflow-hidden rounded-lg shadow-lg">
            <div className="flex flex-col items-center justify-center h-full  p-5">
              <svg
                className="size-24 xl:size-28 icon"
                viewBox="0 0 1024 1024"
                fill="#60a5fa"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M392.07 657.084a7.8 7.8 0 0 1-3.856-1c-81.426-44.952-132.016-130.796-132.016-224.028 0-141.054 114.762-255.816 255.818-255.816a7.988 7.988 0 0 1 7.994 7.994 7.99 7.99 0 0 1-7.994 7.994c-132.25 0-239.83 107.586-239.83 239.828 0 87.406 47.42 167.88 123.74 210.038a7.984 7.984 0 0 1 3.138 10.868 8 8 0 0 1-6.994 4.122z"
                    fill=""
                  ></path>
                  <path
                    d="M631.946 657.084a7.996 7.996 0 0 1-6.994-4.124 7.988 7.988 0 0 1 3.136-10.868c76.32-42.156 123.74-122.63 123.74-210.038 0-132.242-107.58-239.828-239.812-239.828a7.99 7.99 0 0 1-7.996-7.994 7.99 7.99 0 0 1 7.996-7.994c141.054 0 255.8 114.762 255.8 255.816 0 93.23-50.588 179.076-132.014 224.028a7.786 7.786 0 0 1-3.856 1.002zM392.1 783.804a7.988 7.988 0 0 1-7.994-7.992v-126.722c0-4.418 3.576-7.994 7.994-7.994s7.994 3.576 7.994 7.994v126.722a7.988 7.988 0 0 1-7.994 7.992z"
                    fill=""
                  ></path>
                  <path
                    d="M631.914 783.804a7.988 7.988 0 0 1-7.994-7.992v-126.536a7.988 7.988 0 0 1 7.994-7.994 7.99 7.99 0 0 1 7.994 7.994v126.536a7.988 7.988 0 0 1-7.994 7.992z"
                    fill=""
                  ></path>
                  <path
                    d="M631.914 687.876H392.1a7.99 7.99 0 0 1-7.994-7.996 7.988 7.988 0 0 1 7.994-7.992h239.814a7.988 7.988 0 0 1 7.994 7.992 7.992 7.992 0 0 1-7.994 7.996zM599.936 815.784h-175.858a7.99 7.99 0 0 1-5.652-2.342l-31.978-31.976a7.992 7.992 0 1 1 11.304-11.304l29.634 29.634h169.24l29.634-29.634a7.988 7.988 0 0 1 11.304 0 7.988 7.988 0 0 1 0 11.304l-31.978 31.976a7.98 7.98 0 0 1-5.65 2.342zM376.112 735.84a7.992 7.992 0 0 1-0.468-15.974l271.79-15.988c4.358-0.14 8.182 3.108 8.448 7.51a7.998 7.998 0 0 1-7.51 8.448l-271.792 15.988c-0.156 0.016-0.312 0.016-0.468 0.016zM376.112 767.816a7.99 7.99 0 0 1-7.978-7.526 8 8 0 0 1 7.51-8.448l271.79-15.988c4.358-0.312 8.182 3.108 8.448 7.512 0.266 4.402-3.108 8.18-7.51 8.446L376.58 767.8c-0.156 0.016-0.312 0.016-0.468 0.016z"
                    fill=""
                  ></path>
                  <path
                    d="M512.016 847.76c-44.406 0-62.362-34.912-63.112-36.396a7.996 7.996 0 0 1 14.286-7.182c0.624 1.218 14.598 27.59 48.826 27.59 34.272 0 48.23-26.464 48.808-27.59a8.016 8.016 0 0 1 10.742-3.514 7.99 7.99 0 0 1 3.544 10.696c-0.748 1.484-18.706 36.396-63.094 36.396zM472.042 655.896a7.988 7.988 0 0 1-7.994-7.994v-63.954a7.99 7.99 0 0 1 7.994-7.996 7.99 7.99 0 0 1 7.996 7.996v63.954a7.99 7.99 0 0 1-7.996 7.994zM551.97 655.896a7.988 7.988 0 0 1-7.994-7.994v-63.954c0-4.42 3.576-7.996 7.994-7.996s7.994 3.576 7.994 7.996v63.954a7.988 7.988 0 0 1-7.994 7.994z"
                    fill=""
                  ></path>
                  <path
                    d="M472.042 591.944a8 8 0 0 1-6.246-2.998 8.006 8.006 0 0 1 1.25-11.242l39.972-31.976c3.482-2.75 8.496-2.188 11.242 1.248a8.004 8.004 0 0 1-1.248 11.242l-39.972 31.976a7.966 7.966 0 0 1-4.998 1.75z"
                    fill=""
                  ></path>
                  <path
                    d="M551.97 591.944a7.916 7.916 0 0 1-4.996-1.75l-39.956-31.976a8.008 8.008 0 0 1-1.25-11.242 8.006 8.006 0 0 1 11.242-1.248l39.956 31.976a8.006 8.006 0 0 1 1.25 11.242 8 8 0 0 1-6.246 2.998zM472.042 559.964a7.988 7.988 0 0 1-7.994-7.994v-111.92a7.99 7.99 0 0 1 7.994-7.994 7.99 7.99 0 0 1 7.996 7.994v111.92a7.99 7.99 0 0 1-7.996 7.994z"
                    fill=""
                  ></path>
                  <path
                    d="M472.042 448.044a7.988 7.988 0 0 1-7.994-7.994c0-13.224-10.758-23.982-23.982-23.982s-23.982 10.758-23.982 23.982a7.988 7.988 0 0 1-7.994 7.994 7.99 7.99 0 0 1-7.996-7.994c0-22.04 17.924-39.97 39.972-39.97s39.972 17.932 39.972 39.97a7.99 7.99 0 0 1-7.996 7.994z"
                    fill=""
                  ></path>
                  <path
                    d="M440.066 480.024c-22.046 0-39.972-17.934-39.972-39.972a7.99 7.99 0 0 1 7.996-7.994 7.99 7.99 0 0 1 7.994 7.994c0 13.226 10.758 23.984 23.982 23.984 4.418 0 7.994 3.576 7.994 7.994s-3.576 7.994-7.994 7.994zM551.97 559.964a7.988 7.988 0 0 1-7.994-7.994v-111.92c0-4.418 3.576-7.994 7.994-7.994s7.994 3.576 7.994 7.994v111.92a7.988 7.988 0 0 1-7.994 7.994z"
                    fill=""
                  ></path>
                  <path
                    d="M615.926 448.044a7.988 7.988 0 0 1-7.994-7.994c0-13.224-10.758-23.982-23.984-23.982-13.224 0-23.982 10.758-23.982 23.982 0 4.42-3.576 7.994-7.994 7.994s-7.994-3.574-7.994-7.994c0-22.04 17.924-39.97 39.97-39.97s39.972 17.932 39.972 39.97a7.988 7.988 0 0 1-7.994 7.994z"
                    fill=""
                  ></path>
                  <path
                    d="M583.948 480.024c-4.418 0-7.994-3.576-7.994-7.996s3.576-7.994 7.994-7.994c13.226 0 23.984-10.758 23.984-23.984a7.988 7.988 0 0 1 7.994-7.994 7.99 7.99 0 0 1 7.994 7.994c0 22.04-17.926 39.974-39.972 39.974zM328.146 440.05a7.99 7.99 0 0 1-7.994-7.994c0-105.792 86.062-191.864 191.864-191.864a7.99 7.99 0 0 1 7.994 7.994 7.99 7.99 0 0 1-7.994 7.996c-96.978 0-175.876 78.896-175.876 175.874a7.988 7.988 0 0 1-7.994 7.994zM520.01 480.024h-15.99c-4.418 0-7.994-3.576-7.994-7.996s3.576-7.994 7.994-7.994h15.99c4.418 0 7.994 3.576 7.994 7.994s-3.576 7.996-7.994 7.996z"
                    fill=""
                  ></path>
                  <path
                    d="M53.888 687.938c-3.264 0-6.324-2-7.51-5.246C26.456 628.168 16.354 570.738 16.354 512 16.354 238.704 238.694 16.354 512 16.354c70.856 0 139.198 14.538 203.12 43.204a7.99 7.99 0 0 1 4.03 10.564c-1.794 4.036-6.542 5.816-10.554 4.02-61.864-27.74-128.02-41.8-196.596-41.8C247.516 32.342 32.342 247.516 32.342 512c0 56.866 9.774 112.452 29.056 165.196a8.004 8.004 0 0 1-4.762 10.258 8.084 8.084 0 0 1-2.748 0.484z"
                    fill=""
                  ></path>
                  <path
                    d="M663.876 80.308a8.012 8.012 0 0 1-7.932-7.09 7.992 7.992 0 0 1 7.042-8.844l47.964-5.464c4.262-0.57 8.338 2.638 8.854 7.034a7.996 7.996 0 0 1-7.042 8.846l-47.964 5.464a7.526 7.526 0 0 1-0.922 0.054z"
                    fill=""
                  ></path>
                  <path
                    d="M711.858 74.844a7.97 7.97 0 0 1-6.386-3.186l-31.976-42.5a7.994 7.994 0 1 1 12.772-9.618l31.976 42.5a7.994 7.994 0 0 1-6.386 12.804z"
                    fill=""
                  ></path>
                  <path
                    d="M512 1007.646c-70.888 0-139.23-14.552-203.136-43.236-4.028-1.794-5.824-6.542-4.012-10.57a8.012 8.012 0 0 1 10.57-4.012c61.832 27.746 127.972 41.83 196.58 41.83 264.482 0 479.658-215.176 479.658-479.658 0-56.85-9.76-112.412-29.012-165.14a7.998 7.998 0 0 1 4.762-10.25 8.006 8.006 0 0 1 10.258 4.77c19.892 54.494 29.98 111.898 29.98 170.622C1007.646 785.304 785.304 1007.646 512 1007.646z"
                    fill=""
                  ></path>
                  <path
                    d="M312.126 965.114a7.996 7.996 0 0 1-7.932-7.088 7.968 7.968 0 0 1 7.042-8.838l47.966-5.434c4.31-0.562 8.338 2.624 8.852 7.028a7.968 7.968 0 0 1-7.042 8.836l-47.966 5.434a6.148 6.148 0 0 1-0.92 0.062z"
                    fill=""
                  ></path>
                  <path
                    d="M344.12 1007.646a7.95 7.95 0 0 1-6.386-3.186l-31.978-42.532c-2.654-3.53-1.952-8.556 1.578-11.196 3.56-2.656 8.556-1.954 11.196 1.576l31.978 42.534c2.654 3.528 1.952 8.554-1.578 11.196a8.06 8.06 0 0 1-4.81 1.608z"
                    fill=""
                  ></path>
                  <path
                    d="M743.834 192.228a7.99 7.99 0 0 1-7.994-7.994V144.262c0-4.418 3.576-7.994 7.994-7.994s7.994 3.576 7.994 7.994v39.972a7.99 7.99 0 0 1-7.994 7.994z"
                    fill=""
                  ></path>
                  <path
                    d="M879.736 288.16c-79.35 0-143.896-64.556-143.896-143.898S800.386 0.366 879.736 0.366s143.898 64.554 143.898 143.896-64.548 143.898-143.898 143.898z m0-271.806c-70.528 0-127.908 57.38-127.908 127.908 0 70.528 57.38 127.91 127.908 127.91s127.91-57.38 127.91-127.91c0-70.528-57.382-127.908-127.91-127.908z"
                    fill=""
                  ></path>
                  <path
                    d="M879.736 328.13c-79.35 0-143.896-64.554-143.896-143.896 0-4.42 3.576-7.994 7.994-7.994s7.994 3.574 7.994 7.994c0 70.528 57.38 127.908 127.908 127.908s127.91-57.38 127.91-127.908a7.988 7.988 0 0 1 7.994-7.994 7.988 7.988 0 0 1 7.994 7.994c0 79.342-64.548 143.896-143.898 143.896z"
                    fill=""
                  ></path>
                  <path
                    d="M879.736 200.222a7.99 7.99 0 0 1-7.994-7.994V96.296a7.99 7.99 0 0 1 7.994-7.994 7.99 7.99 0 0 1 7.996 7.994v95.932a7.99 7.99 0 0 1-7.996 7.994zM1015.64 192.228a7.988 7.988 0 0 1-7.994-7.994V144.262a7.988 7.988 0 0 1 7.994-7.994 7.99 7.99 0 0 1 7.994 7.994v39.972a7.99 7.99 0 0 1-7.994 7.994zM823.778 316.092a7.988 7.988 0 0 1-7.994-7.994v-39.972a7.988 7.988 0 0 1 7.994-7.994 7.99 7.99 0 0 1 7.994 7.994v39.972a7.988 7.988 0 0 1-7.994 7.994zM951.686 307.522a7.99 7.99 0 0 1-7.994-7.996v-39.972c0-4.418 3.576-7.994 7.994-7.994s7.994 3.576 7.994 7.994v39.972a7.99 7.99 0 0 1-7.994 7.996z"
                    fill=""
                  ></path>
                  <path
                    d="M8.36 887.732a7.988 7.988 0 0 1-7.994-7.994v-39.972a7.988 7.988 0 0 1 7.994-7.994 7.99 7.99 0 0 1 7.994 7.994v39.972a7.99 7.99 0 0 1-7.994 7.994z"
                    fill=""
                  ></path>
                  <path
                    d="M144.262 983.664c-79.35 0-143.896-64.548-143.896-143.898s64.546-143.896 143.896-143.896 143.898 64.546 143.898 143.896-64.548 143.898-143.898 143.898z m0-271.806c-70.528 0-127.908 57.38-127.908 127.908s57.38 127.91 127.908 127.91 127.908-57.382 127.908-127.91-57.38-127.908-127.908-127.908z"
                    fill=""
                  ></path>
                  <path
                    d="M144.262 1023.634c-79.35 0-143.896-64.548-143.896-143.896a7.99 7.99 0 0 1 7.994-7.996 7.99 7.99 0 0 1 7.994 7.996c0 70.528 57.38 127.908 127.908 127.908s127.908-57.38 127.908-127.908c0-4.42 3.576-7.996 7.996-7.996s7.994 3.576 7.994 7.996c0 79.348-64.548 143.896-143.898 143.896z"
                    fill=""
                  ></path>
                  <path
                    d="M144.262 895.726a7.99 7.99 0 0 1-7.994-7.994V791.8a7.99 7.99 0 0 1 7.994-7.996 7.99 7.99 0 0 1 7.994 7.996v95.932a7.99 7.99 0 0 1-7.994 7.994zM280.166 887.732a7.992 7.992 0 0 1-7.996-7.994v-39.972c0-4.418 3.576-7.994 7.996-7.994s7.994 3.576 7.994 7.994v39.972a7.99 7.99 0 0 1-7.994 7.994zM88.302 1011.612a7.988 7.988 0 0 1-7.994-7.994v-39.97c0-4.42 3.576-7.994 7.994-7.994s7.994 3.574 7.994 7.994v39.97a7.988 7.988 0 0 1-7.994 7.994zM216.21 1003.024a7.988 7.988 0 0 1-7.994-7.992V955.06a7.99 7.99 0 0 1 7.994-7.994 7.99 7.99 0 0 1 7.994 7.994v39.972a7.988 7.988 0 0 1-7.994 7.992z"
                    fill=""
                  ></path>
                </g>
              </svg>
              <h3 className="text-xl xl:text-2xl font-bold text-center px-3">
                Revolutionizing HR for Enhanced Business Impact
              </h3>
            </div>

            <div className="absolute inset-0 bg-primary  text-white flex flex-col items-center justify-center translate-y-full group-hover:translate-y-0 transition-all duration-500 ease-in-out">
              <h3 className="text-2xl font-bold mb-2 text-center">
                Revolutionizing HR for Enhanced Business Impact
              </h3>
              <p className="text-center px-4">
                Traditional HR functions often fail to deliver the business
                impact required to thrive in today’s competitive environment.
                People Process Teck’s innovative approach transforms HR into a
                strategic asset. Our customized, results-driven solutions
                address every business need, from capability enhancement and
                technology integration to cultural transformation. This allows
                you to focus on driving growth while we manage the complexities.
              </p>
            </div>
          </div>

          <div className="group relative w-80 xl:w-1/3 sm:w-96  h-80 bg-white overflow-hidden rounded-lg shadow-lg ">
            <div className="flex flex-col items-center justify-center h-full  p-5">
              <svg
                className=" size-28 icon"
                viewBox="0 0 1024 1024"
                fill="#60a5fa"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M545.5395 1023.356c-12.29 0-24.57-4.678-33.922-14.022a7.988 7.988 0 0 1 0-11.304 7.992 7.992 0 0 1 11.306 0c12.49 12.474 32.79 12.458 45.25-0.016 12.454-12.468 12.446-32.752-0.032-45.218a7.988 7.988 0 0 1 0-11.304 7.988 7.988 0 0 1 11.304 0c18.706 18.69 18.72 49.114 0.032 67.828-9.354 9.35-21.652 14.036-33.938 14.036zM624.7095 944.236c-12.828 0-24.882-4.996-33.946-14.068a7.988 7.988 0 0 1 0-11.304 7.988 7.988 0 0 1 11.304 0c12.07 12.078 33.14 12.11 45.218 0.032 12.468-12.466 12.46-32.76-0.016-45.234l-62.176-62.208a7.992 7.992 0 1 1 11.304-11.304l62.176 62.208c18.714 18.706 18.714 49.146 0.016 67.844-9.038 9.046-21.074 14.034-33.88 14.034zM703.8195 865.08c-12.29 0-24.568-4.676-33.922-14.03l-62.176-62.178a7.992 7.992 0 1 1 11.304-11.304l62.176 62.178c12.476 12.474 32.76 12.474 45.234 0 12.476-12.476 12.476-32.776 0-45.252l-62.192-62.16c-3.124-3.122-3.124-8.182 0-11.304s8.184-3.124 11.304 0l62.192 62.16c18.714 18.708 18.714 49.156 0 67.862-9.35 9.352-21.63 14.028-33.92 14.028zM782.9675 785.932c-12.28 0-24.558-4.67-33.914-14.008l-62.2-62.214a7.992 7.992 0 0 1 0-11.304 7.988 7.988 0 0 1 11.304 0l62.192 62.208c12.476 12.446 32.76 12.46 45.22 0 12.474-12.476 12.474-32.774 0-45.25L596.4175 506.222a7.988 7.988 0 0 1 0-11.304 7.988 7.988 0 0 1 11.304 0l209.154 209.138c18.712 18.708 18.712 49.154 0 67.86-9.336 9.346-21.618 14.016-33.908 14.016zM195.5575 666.348a7.988 7.988 0 0 1-7.128-4.366c-34.624-67.914-46.016-134.68-46.484-137.492a7.996 7.996 0 0 1 6.566-9.196c4.396-0.656 8.47 2.224 9.204 6.566 0.11 0.672 11.5 67.234 44.954 132.864a7.988 7.988 0 0 1-7.112 11.624zM434.9495 381.682a7.964 7.964 0 0 1-3.084-0.618c-55.508-23.242-93.164-42.814-93.538-43.01a8.004 8.004 0 0 1-3.388-10.79 7.974 7.974 0 0 1 10.79-3.388c0.368 0.196 37.466 19.48 92.304 42.432a8 8 0 0 1-3.084 15.374zM814.9335 676.154a7.992 7.992 0 0 1-6.504-12.64c47.724-66.914 56.922-162.708 57.008-163.668 0.406-4.388 4.176-7.682 8.69-7.238a8 8 0 0 1 7.236 8.69c-0.376 4.09-9.704 101.104-59.91 171.508a8.002 8.002 0 0 1-6.52 3.348zM477.7015 1000.76h-0.008c-12.804 0-24.85-4.996-33.906-14.05-18.69-18.684-18.69-49.118-0.008-67.838l33.922-33.922c18.144-18.126 49.732-18.112 67.83 0.016 18.698 18.698 18.698 49.13 0 67.83l-33.9 33.898c-9.072 9.07-21.12 14.066-33.93 14.066z m33.922-113.86a31.83 31.83 0 0 0-22.626 9.362l-33.906 33.906c-12.452 12.484-12.46 32.776 0 45.236a31.756 31.756 0 0 0 22.602 9.368h0.008c8.542 0 16.576-3.332 22.624-9.382l33.9-33.898c12.466-12.468 12.466-32.754 0-45.22a31.72 31.72 0 0 0-22.602-9.372zM398.5515 921.62c-12.804 0-24.842-4.988-33.898-14.044-18.69-18.712-18.69-49.146 0-67.86l45.22-45.22c18.128-18.104 49.748-18.12 67.828 0 18.706 18.708 18.706 49.14 0 67.846l-45.218 45.218c-9.066 9.064-21.12 14.06-33.932 14.06z m45.25-125.172a31.792 31.792 0 0 0-22.624 9.352l-45.22 45.22c-12.46 12.474-12.46 32.776 0 45.25a31.746 31.746 0 0 0 22.594 9.362 31.82 31.82 0 0 0 22.626-9.376l45.218-45.218c12.468-12.468 12.468-32.768 0-45.236a31.7 31.7 0 0 0-22.594-9.354zM319.4175 842.462c-12.82 0-24.858-4.98-33.9-14.04-9.064-9.046-14.06-21.094-14.068-33.906a47.664 47.664 0 0 1 14.038-33.938l33.93-33.914c18.12-18.136 49.74-18.122 67.844 0.016 9.064 9.042 14.054 21.08 14.054 33.898 0 12.804-4.99 24.852-14.054 33.914l-33.93 33.93c-9.064 9.06-21.11 14.04-33.914 14.04z m33.916-113.858a31.756 31.756 0 0 0-22.61 9.368l-33.93 33.914a31.77 31.77 0 0 0-9.352 22.624 31.808 31.808 0 0 0 9.384 22.61c12.054 12.07 33.118 12.07 45.204 0l33.93-33.93a31.772 31.772 0 0 0 9.37-22.61c0-8.54-3.326-16.558-9.362-22.586a31.778 31.778 0 0 0-22.634-9.39zM240.2775 763.33h-0.008c-12.812 0-24.85-4.982-33.898-14.04-18.7-18.712-18.7-49.144 0-67.844l22.61-22.61c18.12-18.128 49.692-18.098 67.812 0.016 9.064 9.062 14.054 21.102 14.062 33.906s-4.982 24.844-14.046 33.906l-22.61 22.61c-9.066 9.066-21.112 14.056-33.922 14.056z m22.594-102.548a31.74 31.74 0 0 0-22.586 9.362l-22.61 22.61c-12.46 12.468-12.46 32.758 0 45.234a31.734 31.734 0 0 0 22.594 9.354h0.008c8.542 0 16.574-3.326 22.618-9.37l22.61-22.61c6.042-6.042 9.362-14.068 9.362-22.602s-3.334-16.558-9.376-22.602c-6.054-6.042-14.08-9.376-22.62-9.376zM409.8875 548.506c-12.29 0-24.578-4.684-33.93-14.038-18.698-18.698-18.698-49.114 0-67.812l73.482-73.512c68.922-68.922 224.082-91.758 230.646-92.702 4.326-0.696 8.418 2.404 9.05 6.784a7.998 7.998 0 0 1-6.786 9.048c-1.562 0.218-156.464 23.03-221.608 88.174l-73.48 73.512c-12.46 12.46-12.46 32.744 0 45.204 12.468 12.476 32.75 12.476 45.22 0.016 4.154-4.154 102.328-101.134 152.63-50.886a7.992 7.992 0 0 1 0 11.304 7.988 7.988 0 0 1-11.304 0c-32.432-32.384-104.852 25.732-130.022 50.886-9.344 9.346-21.624 14.022-33.898 14.022zM907.3315 497.26a7.96 7.96 0 0 1-5.652-2.342L686.8715 280.096a7.992 7.992 0 0 1 0-11.304 7.988 7.988 0 0 1 11.304 0l214.808 214.822a7.992 7.992 0 0 1-5.652 13.646zM986.4795 463.33a7.96 7.96 0 0 1-5.652-2.342L720.7855 200.962a7.992 7.992 0 0 1 0-11.304 7.988 7.988 0 0 1 11.304 0l260.042 260.026a7.992 7.992 0 0 1-5.652 13.646z"
                    fill=""
                  ></path>
                  <path
                    d="M692.5235 282.438a7.992 7.992 0 0 1-5.652-13.646l33.914-33.916a7.992 7.992 0 1 1 11.304 11.304l-33.914 33.916a7.96 7.96 0 0 1-5.652 2.342zM907.3315 497.26a7.96 7.96 0 0 1-5.652-2.342 7.988 7.988 0 0 1 0-11.304l33.914-33.916a7.992 7.992 0 1 1 11.304 11.306l-33.914 33.914a7.968 7.968 0 0 1-5.652 2.342zM726.4375 203.304a7.992 7.992 0 0 1-5.652-13.646l186.672-186.67a7.992 7.992 0 1 1 11.304 11.304l-186.672 186.67a7.96 7.96 0 0 1-5.652 2.342zM986.4795 463.33a7.96 7.96 0 0 1-5.652-2.342 7.988 7.988 0 0 1 0-11.304l29.528-29.496a7.992 7.992 0 1 1 11.304 11.304l-29.528 29.496a7.966 7.966 0 0 1-5.652 2.342zM115.9175 519.838a7.992 7.992 0 0 1-5.654-13.646L325.0855 291.4c3.122-3.124 8.182-3.124 11.304 0s3.124 8.182 0 11.304L121.5695 517.496a7.978 7.978 0 0 1-5.652 2.342zM36.7835 485.94a7.966 7.966 0 0 1-5.652-2.342 7.988 7.988 0 0 1 0-11.304l260.042-260.026a7.988 7.988 0 0 1 11.304 0 7.988 7.988 0 0 1 0 11.304L42.4355 483.598a7.968 7.968 0 0 1-5.652 2.342z"
                    fill=""
                  ></path>
                  <path
                    d="M115.9175 519.838a7.98 7.98 0 0 1-5.654-2.342l-33.914-33.898c-3.124-3.124-3.124-8.182 0-11.304s8.182-3.124 11.304 0l33.916 33.898a7.992 7.992 0 0 1-5.652 13.646zM330.7395 305.046a7.966 7.966 0 0 1-5.652-2.342l-33.916-33.914a7.988 7.988 0 0 1 0-11.304 7.988 7.988 0 0 1 11.304 0l33.916 33.914a7.988 7.988 0 0 1 0 11.304 7.968 7.968 0 0 1-5.652 2.342zM36.7835 485.94a7.966 7.966 0 0 1-5.652-2.342l-28.2-28.2a7.994 7.994 0 0 1 11.304-11.306l28.2 28.2a7.988 7.988 0 0 1 0 11.304 7.962 7.962 0 0 1-5.652 2.344zM296.8235 225.914a7.978 7.978 0 0 1-5.652-2.342L81.9555 14.354c-3.124-3.124-3.124-8.182 0-11.304s8.182-3.124 11.304 0l209.216 209.216a7.988 7.988 0 0 1 0 11.304 7.964 7.964 0 0 1-5.652 2.344zM23.9635 415.784a23.848 23.848 0 0 1-16.974-7.026c-9.33-9.376-9.314-24.584 0.016-33.914 9.026-9.056 24.882-9.064 33.922 0.008a23.778 23.778 0 0 1 7.01 16.942 23.796 23.796 0 0 1-7.018 16.964 23.78 23.78 0 0 1-16.956 7.026z m0-31.978c-2.14 0-4.146 0.828-5.644 2.334a8.024 8.024 0 0 0-0.008 11.328c2.982 2.974 8.284 2.998 11.296-0.008a7.944 7.944 0 0 0 2.342-5.66c0-2.14-0.828-4.146-2.334-5.652a7.912 7.912 0 0 0-5.652-2.342z"
                    fill=""
                  ></path>
                </g>
              </svg>
              <h3 className="text-xl font-bold text-center xl:text-2xl">
                Comprehensive Staffing Solutions
              </h3>
            </div>

            <div className="absolute inset-0 bg-primary  text-white flex flex-col items-center justify-center translate-y-full group-hover:translate-y-0 transition-all duration-500 ease-in-out">
              <h3 className="text-2xl font-bold mb-2 text-center px-3">
                Comprehensive Staffing Solutions
              </h3>
              <p className="text-center px-4">
                People Process Teck, has a proven track record of delivering
                comprehensive staffing solutions. With years of experience, we
                have consistently met the manpower needs of various industries,
                ensuring satisfaction for both employers and employees.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4 lg:p-8 xl:p-10 2xl:p-8 ">
        <h1 className="text-center text-4xl font-bold text-gray-900 leading-tight">
          Nationwide Service<span className="text-primary"> Delivery</span>
        </h1>
        <p className="mt-4 text-center px-4 lg:px-10 xl:px-28 2xl:px-12">
          With a solid foundation and extensive experience, People Process Teck
          is strategically positioned to deliver services across India. We
          implement solutions on a turnkey basis with unmatched effectiveness,
          ensuring your business achieves its objectives.
        </p>
        <div className="grid lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 mt-8 gap-20 place-items-center">
          <img
            src={certificateOne}
            alt=""
            className="block w-[550px] h-[641px]"
          />
          <img
            src={certificateOTwo}
            alt=""
            className="block w-[550px] h-[641px]"
          />
        </div>
      </div>
      <br />
      <div
        className="h-[75rem] w-auto lg:h-[32rem] xl:h-[32rem] 2xl:h-[32rem] bg-cover bg-center"
        style={{ backgroundImage: `url(${contactUsBg})` }}
      >
        <div className="h-full bg-primary/70 grid lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2">
          <div className="p-4 flex flex-col gap-6 justify-center">
            <h1 className="p-2 w-fit bg-primary/80 rounded-md font-bold text-white">
              Connect With Us
            </h1>
            <h1 className=" text-4xl font-bold text-white">
              Contact Us for Expert Guidance
            </h1>
            <p className="text-xl text-white">
              We provide professional advice and guidance on HR, IR and
              Compliance matters, helping clients understand their rights,
              obligations, and potential courses.
            </p>
          </div>
          <div className="p-6">
            <div className="h-fit bg-white w-auto rounded-md p-4">
              <form
                className="mt-4"
                ref={formRef}
                onSubmit={handleSubmit(handleOnSubmit)}
              >
                <div className="flex justify-content-between gap-10">
                  <div>
                    <input
                      {...register("name", {
                        required: { value: true, message: "Name is required" },
                        maxLength: {
                          value: 25,
                          message: "Name must not exceed 25 characters",
                        },
                      })}
                      className="p-2 bg-gray-100 w-full focus:outline-none placeholder:text-gray-600 rounded-md"
                      placeholder=" Name"
                    />
                    {errors.name && (
                      <p className="mt-2 text-xs text-red-600">
                        {errors.name.message}
                      </p>
                    )}
                  </div>

                  <div>
                    <input
                      {...register("mobileNumber", {
                        required: {
                          value: true,
                          message: "Mobile number is required",
                        },
                        pattern: {
                          value: /^(?:\+91[-\s]?|0)?[6-9]\d{9}$/,
                          message: "Invalid Mobile Number",
                        },
                      })}
                      className="p-2 w-full bg-gray-100  focus:outline-none placeholder:text-gray-600 rounded-md"
                      placeholder="Mobile Number"
                    />
                    {errors.mobileNumber && (
                      <p className="mt-2 text-xs text-red-600">
                        {errors.mobileNumber.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="mt-4 gap-4">
                  <input
                    {...register("email", {
                      required: { value: true, message: "Email is required" },
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: "Invalid Email",
                      },
                    })}
                    className="w-full p-2 bg-gray-100  focus:outline-none placeholder:text-gray-600 rounded-md"
                    placeholder="Email ID"
                  />
                  {errors.email && (
                    <p className="mt-2 text-xs text-red-600">
                      {errors.email.message}
                    </p>
                  )}
                </div>
                <div className="mt-4 gap-4">
                  <textarea
                    {...register("servicesRequired", {
                      required: {
                        value: true,
                        message: "Services details is required",
                      },
                      maxLength: {
                        value: 250,
                        message:
                          "Service details must not exceed 250 characters",
                      },
                    })}
                    rows={4}
                    className="w-full p-2 bg-gray-100 focus:outline-none placeholder:text-gray-600 rounded-md"
                    placeholder="Service Required"
                  />
                  {errors.servicesRequired && (
                    <p className="mt-2 text-xs text-red-600">
                      {errors.servicesRequired.message}
                    </p>
                  )}
                </div>
                <div className="flex justify-center mt-2">
                  <button
                    className={`p-2 bg-primary text-white rounded-md w-full`}
                  >
                    SUBMIT
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AboutUs;
